var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333.16 45.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5b3d3a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.25,45.63A8.07,8.07,0,0,1,.5,40.89a15.58,15.58,0,0,1,2.21-4.1,35.62,35.62,0,0,1,6.38-6.37,87.26,87.26,0,0,1,15.06-9.25,157.15,157.15,0,0,1,16.21-6.78c5.54-1.91,11.16-3.55,16.85-5s11.36-2.86,17.21-4a63.67,63.67,0,0,1,18-.92A54.13,54.13,0,0,1,110.5,9.22c5.73,2.67,11.07,6.92,13.9,12.46l-1,1a50.54,50.54,0,0,0-15.74-3.94A112.08,112.08,0,0,0,92,18.56c-5.29.26-10.64.52-16.13.61a145.38,145.38,0,0,0-16.58,1.19q-8.25,1.11-16.41,2.93A151.76,151.76,0,0,0,26.79,27.6,85.91,85.91,0,0,0,11.54,34a32.27,32.27,0,0,0-6.6,4.69c-1.89,1.8-3.52,4.06-3.32,6.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.58,38.71c.14-2.56-1.53-4.78-3.45-6.54a32.51,32.51,0,0,0-6.67-4.53,85.66,85.66,0,0,0-15.34-6.08A150.85,150.85,0,0,0,290,17.62q-8.14-1.63-16.41-2.56a114.48,114.48,0,0,0-16.42-.62c-5.43.12-10.74.2-16,.18a155.55,155.55,0,0,0-15.85.74c-2.64.28-5.28.65-7.93,1.2a51.45,51.45,0,0,0-8.07,2.29l-.93-1A20.25,20.25,0,0,1,211.05,14a27.39,27.39,0,0,1,3.4-3.24,41.63,41.63,0,0,1,7.93-5A60.34,60.34,0,0,1,240,.61a61.74,61.74,0,0,1,18,.1c5.91.84,11.69,2.16,17.4,3.4s11.34,2.79,16.89,4.58a154.89,154.89,0,0,1,16.31,6.4A86.62,86.62,0,0,1,323.82,24a35.6,35.6,0,0,1,6.49,6.21,15.3,15.3,0,0,1,2.29,4,8,8,0,0,1,.36,4.71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset51);
export default __webpack_public_path__ + "static/media/Asset 51.4244dcde.svg";
export { ForwardRef as ReactComponent };